/**
 * Determines the color for time picker text components based on state
 * @param {Object} theme - Material-UI theme object
 * @param {boolean} isSelected - Whether the component is selected
 * @param {boolean} disabled - Whether the component is disabled
 * @returns {string} The appropriate color value
 */
export const getColor = (theme, isSelected, disabled) => {
  if (isSelected) {
    return theme.palette.generic.primary;
  }
  if (disabled) {
    return theme.palette.text.disabled;
  }
  return theme.palette.text.title;
};